import script from "./WCDesktopOTSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./WCDesktopOTSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./WCDesktopOTSwitcher.vue?vue&type=style&index=0&id=4e1af3af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e1af3af"]])

export default __exports__